module.exports = __webpack_public_path__ + "media/images/hero-image-9a4bf9d07b7bd9e1afc18df3c2752e7d.jpg";